module.exports = {
  schema: {
    name: '片種代碼',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '片種代碼',
      },
      brandRef: {
        type: 'ObjectId',
        reference: 'brands',
        refKeys: ['key'],
        input: 'select',
        name: '品牌代碼',
      },
      supplierRef: {
        type: 'ObjectId',
        reference: 'suppliers',
        refKeys: ['name'],
        input: 'select',
        name: '供應商名稱',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'brandRef', width: 130 },
        { key: 'supplierRef', width: 130 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '片種代碼資料',
          rows: [
            [{ key: 'key' }],
            [{ key: 'brandRef' }],
            [{ key: 'supplierRef' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/lensTypes.js